export const SEARCH_PARAM_KEY = 'search';

export const SEARCH_VALIDATION = {
  MIN: 50,
  MAX: 60,
};
